module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "marketing_name",
      "rules": {
        required: true,
        message: '活动名称必填',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "最多30个字"
    },
    model: {
      value: (_vm.form.marketing_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "marketing_name", $$v)
      },
      expression: "form.marketing_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "促销规则"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 1
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "quantity"
    },
    model: {
      value: (_vm.form.condition_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "condition_type", $$v)
      },
      expression: "form.condition_type"
    }
  }, [_vm._v("按订单总件数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "totalfee"
    },
    model: {
      value: (_vm.form.condition_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "condition_type", $$v)
      },
      expression: "form.condition_type"
    }
  }, [_vm._v("按订单总金额")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._l((_vm.conditionValue), function(item, key) {
    return (_vm.form.condition_type == 'totalfee') ? _c('span', {
      key: key
    }, [_vm._v("消费满 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "input",
        "placeholder": "0.00",
        "size": "mini"
      },
      model: {
        value: (item.full),
        callback: function($$v) {
          _vm.$set(item, "full", $$v)
        },
        expression: "item.full"
      }
    }), _vm._v(" 元，送赠品")], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.conditionValue), function(item, key) {
    return (_vm.form.condition_type == 'quantity') ? _c('span', {
      key: key
    }, [_vm._v("消费满 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "input",
        "placeholder": "0.00",
        "size": "mini"
      },
      model: {
        value: (item.full),
        callback: function($$v) {
          _vm.$set(item, "full", $$v)
        },
        expression: "item.full"
      }
    }), _vm._v(" 件，送赠品")], 1) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "el-icon-plus",
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": ""
    },
    on: {
      "click": _vm.relGiftsClick
    }
  }, [_vm._v("选赠品")]), _vm._v(" "), (_vm.relGifts.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.relGifts
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠品数量",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "90",
            "size": "mini"
          },
          model: {
            value: (scope.row.gift_num),
            callback: function($$v) {
              _vm.$set(scope.row, "gift_num", $$v)
            },
            expression: "scope.row.gift_num"
          }
        })]
      }
    }], null, false, 816364937)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteGiftRow(scope.$index)
            }
          }
        })]
      }
    }], null, false, 1531580622)
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规则描述"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "规则描述"
    },
    model: {
      value: (_vm.form.marketing_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "marketing_desc", $$v)
      },
      expression: "form.marketing_desc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可参与次数"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "input",
      "placeholder": "整数数字"
    },
    model: {
      value: (_vm.form.join_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "join_limit", $$v)
      },
      expression: "form.join_limit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用会员"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.validGrade),
      callback: function($$v) {
        _vm.validGrade = $$v
      },
      expression: "validGrade"
    }
  }, [_vm._l((_vm.memberGrade), function(grade) {
    return _c('el-checkbox', {
      key: grade.grade_id,
      attrs: {
        "label": grade.grade_id
      }
    }, [_vm._v(_vm._s(grade.grade_name))])
  }), _vm._v(" "), _vm._l((_vm.vipGrade), function(vipdata) {
    return _c('el-checkbox', {
      key: vipdata.lv_type,
      attrs: {
        "label": vipdata.lv_type
      }
    }, [_vm._v("付费" + _vm._s(vipdata.grade_name))])
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用平台"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.used_platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "used_platform", $$v)
      },
      expression: "form.used_platform"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全场可用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('GoodsSelect', {
    attrs: {
      "items-visible": _vm.giftVisible,
      "get-status": _vm.setGiftStatus,
      "rel-items-ids": _vm.relGifts,
      "is-spec": "",
      "item-type": _vm.form.item_type
    },
    on: {
      "chooseStore": _vm.chooseGiftsAction,
      "closeStoreDialog": _vm.closeGiftsDialogAction
    }
  }), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-data-ids": _vm.relStores,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), (_vm.system_mode !== 'platform' && !_vm.is_distributor) ? _c('el-card', {
    attrs: {
      "header": "绑定店铺",
      "shadow": "naver"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.relStoresClick
    }
  }, [_vm._v("选店铺")]), _vm._v(" "), (_vm.relStores.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.relStores
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteStoreRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3604158687)
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [(_vm.hasSaveButton) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01ebefce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ebefce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/fullgift/add.vue
// module id = 2423
// module chunks = 0